import api from './api';
import performance from './performance';
import createTracker, { PAGE, TRACK, RESET } from '../middleware/segment';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  AUTHENTICATION_INVALIDATE,
  AUTHENTICATION_SUCCESS
} from '../../actions/api/auth';
import { group, identify } from '../../selectors/analytics';
import { ANALYTICS_TRACK } from '../../actions/analytics';
import { PERFORMANCE_MEASURE } from '../../actions/performance';

export function relay(dispatch, state, action) {
  const { type } = action;

  // Track all API calls
  if (api.isType(type)) dispatch({ type: TRACK, payload: { event: type } });

  switch (type) {
    case LOCATION_CHANGE:
      return dispatch({ type: PAGE });
    case AUTHENTICATION_INVALIDATE:
      return dispatch({ type: RESET });
    case api.INITIALIZE:
    case AUTHENTICATION_SUCCESS:
      dispatch(identify(state));
      dispatch(group(state));
      return;
    case ANALYTICS_TRACK:
    case PERFORMANCE_MEASURE:
      dispatch({ type: TRACK, payload: action.payload });

    default:
  }
}

const tracker = createTracker(relay, { config: performance });

export default tracker;



// WEBPACK FOOTER //
// ./js/store/config/analytics.js